module.exports = __webpack_public_path__ + "img/object-404.9fde332.svg";